import { useEffect, useState, useCallback } from "react";
import { getUserWithLocations } from "../../accounts/services/authService";
import { deleteMedia } from "../services/galleryService";

function useMediaWithLocation(projectId) {
    const [mediaWithLocation, setMediaWithLocation] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMediaData = useCallback(async (projectId) => {
        if (!projectId) {
            setMediaWithLocation([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            // 一覧 API はデフォルトで media を含まない（マップ用 Light）。
            // ギャラリーは include_media=1 で media[] 付きレスポンスを取得する。
            // TODO: バックエンドでソート・フィルターを実装したら、クエリパラメータを追加する
            const { locations } = await getUserWithLocations(projectId, {
                include_media: 1,
            });

            // include_media 時は prefetch_related('media') 済みの media 配列を使用（N+1回避）
            // TODO: バックエンドでソート・フィルターを実装したら、フロントエンドでの処理は削除する
            const allMedia = locations.flatMap(location =>
                (location.media || []).map(media => ({ media, location }))
            );

            setMediaWithLocation(allMedia);
        } catch (err) {
            console.error("データ取得エラー:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const deleteMediaItem = useCallback(async (mediaId) => {
        try {
            await deleteMedia(mediaId);
            await fetchMediaData(projectId);
            return true;
        } catch (err) {
            console.error("メディア削除エラー:", err);
            setError(err);
            return false;
        }
    }, [projectId, fetchMediaData]);

    useEffect(() => {
        fetchMediaData(projectId);
    }, [projectId, fetchMediaData]);

    return {
        mediaWithLocation,
        loading,
        error,
        refetch: () => fetchMediaData(projectId),
        deleteMedia: deleteMediaItem
    };
}

export default useMediaWithLocation;
